// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transpos-message-bar {
  display: grid;
  background: #ffffff;
  border: 0.1vw solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  place-items: center;
  height: 2.2vw;
  padding: 0.1vw;
  color: #1a6a7c;
  font-size: 1.5vw;
}

.transpos-top-bar {
  display: grid;
  align-items: center;

  grid-template-columns: min-content auto 2.2vw;
  gap: 0.4vw;
}

a.transpos-logo {
  outline: none;
  height: 2.2vw;
  width: 20vw;
}

img.transpos-logo {
  position: relative;
      bottom: 2.4vw;
    height: 6vw;
}
.transpos-icon {
  cursor: pointer;
  height: 100%;
  width: 2.2vw;
}
#transpos-help-icon:active {
  filter: brightness(0.8);

}
/* .transpos-subtitle {
  display: grid;
  margin-left: 4.5vw;
  font-size: 2vw;
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1;
} */
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Transposition/styles/TransposTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;MACd,aAAa;IACf,WAAW;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;;AAEzB;AACA;;;;;;;GAOG","sourcesContent":[".transpos-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 0.1vw solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  place-items: center;\n  height: 2.2vw;\n  padding: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.5vw;\n}\n\n.transpos-top-bar {\n  display: grid;\n  align-items: center;\n\n  grid-template-columns: min-content auto 2.2vw;\n  gap: 0.4vw;\n}\n\na.transpos-logo {\n  outline: none;\n  height: 2.2vw;\n  width: 20vw;\n}\n\nimg.transpos-logo {\n  position: relative;\n      bottom: 2.4vw;\n    height: 6vw;\n}\n.transpos-icon {\n  cursor: pointer;\n  height: 100%;\n  width: 2.2vw;\n}\n#transpos-help-icon:active {\n  filter: brightness(0.8);\n\n}\n/* .transpos-subtitle {\n  display: grid;\n  margin-left: 4.5vw;\n  font-size: 2vw;\n  margin-bottom: 0;\n  margin-top: 0;\n  line-height: 1;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
